import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { STATUS_CODE } from '../Constants/statuscode.constant';
import { inject } from '@angular/core';
import { CommunicateService } from '../Services/communicate.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const communicate = inject(CommunicateService);
  const toastr = inject(ToastrService);
  const Route = inject(Router);
  let token = localStorage.getItem('sendertoken');
  let newReq = req.clone({
    setHeaders: {
      'Authorization': `Bearer ${token}`
    }
  })
  return next(newReq).pipe(
    catchError((err: any) => {
      const isAuditLogApi = /SentPacketLog\/(AddTempSentPacket|AddTempSentPacketLog)/i.test(req.url);
      if (isAuditLogApi) {
        return throwError(() => err);
      }
      console.log(err)
      if (err instanceof HttpErrorResponse) {
        if (err.status === STATUS_CODE.UNAUTHORIZED) {
          const isPacketAuthQuestionApi = /SentPacketParticipantAuthenticationQuestion/i.test(req.url);
          if (isPacketAuthQuestionApi) {
            return throwError(() => err);
          }
          localStorage.clear()
          toastr.error("Token has been expired. Please login again", "");
          communicate.isLoaderLoad.next(false);
          let routeTo = '/login';
          Route.navigate([routeTo])
        } else {
          console.error('HTTP error:', err);
        }
      } else {
        console.error('An error occurred:', err);
      }
      return throwError(() => err);
    })
  );;
};
